/** Existing server wire limits (validation/schemas.ts); keep UI pending commands admissible. */
export const TRADE_INPUT_LIMITS = { quantity: 9999, gold: 999999999 } as const;
